let opxUpdateConfigDurationFromStart: number;

export function storeOpxUpdateConfigDurationFromStart(durationInMilliSeconds: number) {
    opxUpdateConfigDurationFromStart = durationInMilliSeconds;
}

export function getOpxUpdateConfigDurationFromStart() {
    if (!opxUpdateConfigDurationFromStart) return null;

    return opxUpdateConfigDurationFromStart;
}
